import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpOrderCurve
     * @memberof app
     *
     * @restrict A
     *
     * @description
     * Declare it in a parent element of an order curve iteration and use this directive's controller to get and set
     * general information about the order curve.
     *
     * @author flzemke.btc
     */
    angular.module('app').directive('pkpOrderCurve', pkpOrderCurve);

    function pkpOrderCurve() {
        return {
            restrict: 'A',
            scope: {
                pkpOrderCurve: '='
            },
            controller: OrderCurve
        };

        function OrderCurve($scope, $filter) {
            var vm = this;

            // Active bid first and then by surcharge ascendingly.
            $scope.pkpOrderCurve = $filter('orderBy')($scope.pkpOrderCurve, [
                '-active',
                '+price[0].value'
            ]);

            vm.orderCurve = $scope.pkpOrderCurve;
            vm.onUnitChange = onUnitChange;
            vm.getUnitOfFirstPoint = getUnitOfFirstPoint;

            function onUnitChange() {
                vm.orderCurve.splice(1);
            }

            function getUnitOfFirstPoint(jsonUnitKey) {
                return (
                    vm.orderCurve[0].price[jsonUnitKey] ||
                    vm.orderCurve[0].price[0][jsonUnitKey]
                );
            }
        }
    }
})();
